import { api } from '@/lib/api';
import type { WalkerDetailsRequest, WalkerDetailsResponse } from './types';

const URL = '/vendor/onboarding/module-details/walker';

export async function save_walker_details(
  input: WalkerDetailsRequest,
): Promise<WalkerDetailsResponse> {
  const res = await api.post<WalkerDetailsResponse>(URL, input);
  return res.data;
}

export async function fetch_walker_details(): Promise<WalkerDetailsResponse | null> {
  const res = await api.get<WalkerDetailsResponse | null>(URL);
  return res.data;
}
